// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// `.env.ts` is generated by the `npm run env` command
export const environment = {
  production: false,
  hmr: true,
  serverUrl: 'https://api.zero-waste.pro',
  defaultLanguage: 'fr-FR',
  supportedLanguages: ['fr-FR'],
  resfreshJwtTokenBefore: 360,
  useLocalStorage: false,
  tokenKey: 'token',
  refreshKey: 'refresh_token',
  httpCache: 'httpCache',
};
